import React from 'react';
import { color as palette } from "@/constants/palette";

function Visibility() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
    >
      <mask
        id='mask0_1263_8457'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='25'
        height='25'
      >
        <rect x='0.496094' y='0.012207' width='24' height='24' fill={palette.lineStrong} />
      </mask>
      <g mask='url(#mask0_1263_8457)'>
        <path
          d='M12.4945 16.0122C13.7445 16.0122 14.807 15.5747 15.682 14.6997C16.557 13.8247 16.9945 12.7622 16.9945 11.5122C16.9945 10.2622 16.557 9.19971 15.682 8.32471C14.807 7.44971 13.7445 7.01221 12.4945 7.01221C11.2445 7.01221 10.182 7.44971 9.30703 8.32471C8.43203 9.19971 7.99453 10.2622 7.99453 11.5122C7.99453 12.7622 8.43203 13.8247 9.30703 14.6997C10.182 15.5747 11.2445 16.0122 12.4945 16.0122ZM12.4945 14.2122C11.7445 14.2122 11.107 13.9497 10.582 13.4247C10.057 12.8997 9.79453 12.2622 9.79453 11.5122C9.79453 10.7622 10.057 10.1247 10.582 9.59971C11.107 9.07471 11.7445 8.81221 12.4945 8.81221C13.2445 8.81221 13.882 9.07471 14.407 9.59971C14.932 10.1247 15.1945 10.7622 15.1945 11.5122C15.1945 12.2622 14.932 12.8997 14.407 13.4247C13.882 13.9497 13.2445 14.2122 12.4945 14.2122ZM12.4945 19.0122C10.2612 19.0122 8.2237 18.4122 6.38203 17.2122C4.54036 16.0122 3.0862 14.4289 2.01953 12.4622C1.9362 12.3122 1.8737 12.158 1.83203 11.9997C1.79036 11.8414 1.76953 11.6789 1.76953 11.5122C1.76953 11.3455 1.79036 11.183 1.83203 11.0247C1.8737 10.8664 1.9362 10.7122 2.01953 10.5622C3.0862 8.59554 4.54036 7.01221 6.38203 5.81221C8.2237 4.61221 10.2612 4.01221 12.4945 4.01221C14.7279 4.01221 16.7654 4.61221 18.607 5.81221C20.4487 7.01221 21.9029 8.59554 22.9695 10.5622C23.0529 10.7122 23.1154 10.8664 23.157 11.0247C23.1987 11.183 23.2195 11.3455 23.2195 11.5122C23.2195 11.6789 23.1987 11.8414 23.157 11.9997C23.1154 12.158 23.0529 12.3122 22.9695 12.4622C21.9029 14.4289 20.4487 16.0122 18.607 17.2122C16.7654 18.4122 14.7279 19.0122 12.4945 19.0122Z'
          fill={palette.subtle}
        />
      </g>
    </svg>
  );
}

export default Visibility;
